// extracted by mini-css-extract-plugin
export var standaloneTable = "_1z-0";
export var standaloneTableWithBodyFill = "_1z-1";
export var withExtraHeader = "_1z-2";